const STORAGE_KEYS = {
  ACCESS_TOKEN: 't2_photobinding_access_token',
  REFRESH_TOKEN: 't2_photobinding_refresh_token',
}

export function getToken() {
  return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
}
export function getRefreshToken() {
  return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
}

export function setToken(token) {
  return localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token)
}
export function setRefreshToken(token) {
  return localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, token)
}

export function removeToken() {
  return localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
}
export function removeRefreshToken() {
  return localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
}
